import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import AddNewProvider from "../views/AddNewProvider.vue";
import MyProviders from "../views/MyProviders.vue";
import MyWallet from "../views/MyWallet.vue";
import NotificationsCenter from "../views/NotificationsCenter.vue";
import RecommendToFriend from "../views/RecommendToFriend.vue";
import Statistics from "../views/Statistics.vue";
import UtilitiesHistory from "../views/UtilitiesHistory.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/addnewprovider",
    name: "addnewprovider",
    component: AddNewProvider
  },
  {
    path: "/myproviders",
    name: "myproviders",
    component: MyProviders
  },
  {
    path: "/mywallet",
    name: "mywallet",
    component: MyWallet
  },
  {
    path: "/notificationscenter",
    name: "notificationscenter",
    component: NotificationsCenter
  },
  {
    path: "/recommendtofriend",
    name: "recommendtofriend",
    component: RecommendToFriend
  },
  {
    path: "/statistics",
    name: "statistics",
    component: Statistics
  },
  {
    path: "/utilitieshistory",
    name: "utilitieshistory",
    component: UtilitiesHistory
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;